import axios from "axios";
// import { post } from "request";
import { header } from "./header";

export const GetWorkFlows = async (orgCode,transactionType = 1,Channel) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetWorkFlows?OrgCode=${orgCode}&TransactionType=${transactionType}&Channel=${Channel === undefined?'123':Channel}`,{headers:header()});
        return response;
    } catch (error) {
        return error.response
    }
}

export const GetWorkFlowDefinitionById = async (id) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetWorkFlowDefinitionById?id=${id}`,{headers:header()});
        return response;
    } catch (error) {
        return error.response
    }
}
export const GetWorkFlowDefinitionByIdwithTemplateId = async (obj) => {
  try {
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetWorkFlowDefinitionById?id=${obj.id}&TemplateId=${obj.templateId} &TransactionType=${obj.transactionType}`,{headers:header()});
      return response;
  } catch (error) {
      return error.response
  }
}
export const GetOMSWorkflowTemplateDetails = async (obj) => {
  try {
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetOMSWorkflowTemplateDetails?TransactionType=${obj.transactionType}&TemplateId=${obj.templateId}`,{headers:header()});
      return response;
  } catch (error) {
      return error.response
  }
}

export const GetActions = async (Obj) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetActions?actionType=${Obj.actionType}&TransactionType=${Obj.TransactionType || 1}`,{headers:header()});
        // const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetActions`,{headers:header()});
        return response;
    } catch (error) {
        return error.response
    }
}

export const SaveWorkflow = async (obj) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/SaveWorkflow`, obj,{headers:header()});
        return response;
    } catch (error) {
        return error.response
    }
}

export const UpdateWorkflow = async (obj) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/UpdateWorkflow`, obj,{headers:header()});
        return response;
    } catch (error) {
        return error.response
    }
}


export const workFlowStart =  async(Obj)=>{
    try{      
      const response = await axios.post(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/start?stage=ALL&documentType=${Obj.docType}`, Obj,{headers:header()});
      return response;
    }
    catch(error){
      return error.response
    }
  }

  export const workFlowaction =  async(Obj)=>{
    try{      
      const response = await axios.post(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/action?documentNumber=${Obj.docType}&action=${Obj.action}&remarks=${Obj.remarks}`,'',{headers:header()});
      return response;
    }
    catch(error){
      return error.response
    }
  }
    
  export const subOrderSplitTrack = async(Obj)=>{

    try{
      const response = await axios.post(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/sub-order`, Obj,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }

  export const OmsPerformAction = async(Obj)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/action?documentNumber=${Obj.docNumber}&action=${Obj.action}`,'',{headers:header()})
      return response;
    }
    catch(error){
      return error.response;
    }
  }


  export const OmsMinimalPublish = async(Obj)=>{
    try{
        const response = await axios.post(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/minimal?version=${Obj.workID}&documentType=${Obj.documentType}`,Obj.Channel,{headers:header()});
        return response;
    }
    catch(error){
        return error.response;
    }
  }


  export const IsInventoryAllocated = async(Obj)=>{
    try{
        const response =  await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/IsInventoryAllocated?OrgCode=${Obj.OrgCode}&TransactionType=${Obj.TransType}&TransactionNo=${Obj.transNo}&ItemSku=${Obj.ItemSku}`,{headers:header()});
        return response;
    }
    catch(error){
        return error.response;
    }
  }

  export const ReleaseInventory = async(Obj)=>{
    try{
        const response = await axios.post(`${process.env.REACT_APP_COMMONINVENTORY}/api/TransactionMapping/ReleaseInventory`, Obj,{headers:header()});
        return response;
    }
    catch(error){
        return error.response;
    }
  }

  export const flowNextActions = async(Obj)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_BASE_OMS_QAM}/api/v1/workflow/next-actions?documentNumber=${Obj.documentNO}`,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }

  export const LogisticSubmit = (Obj)=>{
    try{
      const response = axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/LogisticSubmit`, Obj,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }

  /// for Related to Notification Service 

  export const saveOMsComments = async(Obj)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/SaveCommentsForTransaction`, Obj,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }

  export const getTransComments = async(Obj)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetCommentsForTransaction?OrderId=${Obj.Id}&TransactionId=${Obj.transactionId}&OrgCode=${Obj.OrgCode}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

  export const getUserAccessRole = async(Obj)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetRolesbyOrgId?OrgCode=${Obj.OrgCode}&Typename=${Obj.Typename}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

  export const handleServiceNotify = async(Obj)=>{
    try{
      const response = {value: true};
       return response;
      // const response = await post(`${process.env.REACT_APP_OTHER_MASTER_SERVICE}/api/OMS/Savenotification`, Obj`,{headers:header()});
    }
    catch(error){
      return error.response;
    }
  }

  export const getNotifyService = async(Obj)=>{
    try{
      // const response = true;
      const response = await axios.get(`${process.env.REACT_APP_OTHER_MASTER_SERVICE}/api/Notification/GetNotifications?OrgCode=${Obj.OrgCode}&UserName=${Obj.UserName}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

  export const SaveNotificationFromRoleId = async(OBJ)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetUsersFromRoleId`,OBJ,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }

  export const saveWorkFlowforOrder = async(OBJ)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/SaveOrUpdateWorkflowStatus`,OBJ,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }


  export const getOrderWorkflow = async(Obj)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/OMS/GetWorkflowStatus?TransactionNumber=${Obj.TransactionNumber}&TransactionId=${Obj.TransactionId}&OrgCode=${Obj.OrgCode}&SubOrgCode=${Obj.SubOrgCode}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

   export const UpdatealterReadFlag = async(OBJ)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_OTHER_MASTER_SERVICE}/api/Notification/UpdatealterReadFlag`,OBJ,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }
   export const CancelForcreateOrder = async(OBJ)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/CancelOrders/Create`,OBJ,{headers:header()});
      return response;
    }
    catch(error){
      return error.response;
    }
  }
    export const getDatforrefundAmount = async(id)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/CancelOrders/GetDetail?orderId=${id}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

     export const GetRefundAmount = async(payload,id)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/CancelOrders/Approve?id=${id}`,payload,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }
     export const getrejectRequest = async(payload,id)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/CancelOrders/Reject?id=${id}`,payload,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }



    export const gettransactionHistary = async(obj)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/TransactionReport/GetList?orgCode=${obj.orgCode}&subOrgCode=${obj.subOrgCode}&PageNumber=${obj.PageNumber}&PageSize=${obj.PageSize}&Search=${obj.searchVal}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }

     export const ApproveandIgnoreTransaction = async(payload)=>{
    try{
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/TransactionReport/ApproveIgnore`,payload,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }
     export const getTransactionwiseData = async(transactionId)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/TransactionReport/GetDetail?transactionId=${transactionId}`,{headers:header()});
      return response;
    }
    catch(error)
    {
      return error.response;
    }
  }
  